import React from 'react';
import { Link } from 'gatsby';
import PropTypes from 'prop-types';
// Styles
import './style.scss';

const Breadcrumb = (props) => {
  const { location } = props;
  return (
    <div className=" breadcrumb">
      <ul className="wrapper">
        {location
          ? location.map((items, i, arr) => (
              <li key={items.id}>
                <Link
                  style={{ color: 'black', textTransform: 'capitalize' }}
                  to={items.location}
                >
                  {items.value}
                </Link>
                {arr[1].location === '/' ? null : (
                  <span style={{ margin: '0 5px' }}>
                    {i < arr.length - 1 ? '>' : ''}
                  </span>
                )}
              </li>
            ))
          : null}
      </ul>
    </div>
  );
};

Breadcrumb.propTypes = {
  location: PropTypes.array,
};

Breadcrumb.defaultProps = {
  location: [],
};

export default Breadcrumb;
